export const General = {
    name: "SILVINTAGE",
    descrption: " I design elegant and meaningful animated invitation videos for weddings, birthdays, graduations, and more. Using professional tools like Adobe After Effects, I craft refined visuals, smooth transitions, and cinematic details that turn your ideas into beautiful motion stories."
};